<template>
  <div>
    <Form :label-width="105" label-position="left" inline>
      <FormItem label="代理人">
        <Input v-model="formItem.agentEmpCode" />
      </FormItem>
      <FormItem label="被代理人">
        <Input v-model="formItem.empCode" />
      </FormItem>
      <FormItem label="">
        <Button @click="getData"><!-- 检 索 -->{{ $t("Search") }}</Button>
      </FormItem>
    </Form>
    <Table
      border
      :columns="columns"
      :data="data"
      ref="Table"
      id="Table"
      :loading="loading"
    >
      <template
        slot-scope="{ row, index }"
        slot="agentUserName"
        style="width:100%"
      >
        <Input
          v-model="row.agentUserName"
          @on-search="onSelectPeraon(row, index, 'agentUserName')"
          readonly
          search
        ></Input>
      </template>
      <template slot-scope="{ row, index }" slot="userName" style="width:100%">
        <Input
          v-model="row.userName"
          @on-search="onSelectPeraon(row, index, 'userName')"
          readonly
          search
        ></Input>
      </template>
      <template slot-scope="{ row, index }" slot="startDate" style="width:100%">
        <DatePicker
          v-model="row.startDate"
          style="width: 100%"
          :transfer="true"
          @on-change="targetItemChange(row, index, 'startDate')"
        ></DatePicker>
      </template>
      <template slot-scope="{ row, index }" slot="endDate" style="width:100%">
        <DatePicker
          v-model="row.endDate"
          style="width: 100%"
          :transfer="true"
          @on-change="targetItemChange(row, index, 'endDate')"
        ></DatePicker>
      </template>
      <template slot="action1" slot-scope="{ row, index }">
        <Button size="small" @click="onSaveRow(row, index)">保存</Button>
        <Button type="error" size="small" @click="onDeleteRow(row, index)"
          >删除</Button
        >
      </template>
    </Table>
    <div style="display: flex;justify-content: space-between;margin-top: 30px;">
      <Page :total="total" @on-change="pageChange"></Page>
      <div>
        <Button style="margin-left:15px" @click="addRow">新增</Button>
      </div>
    </div>
    <selectPeopleVue
      ref="peoModal"
      @onSelect="onselect"
      @onSelectList="onSelectList"
    />
  </div>
</template>

<script>
import axios from "axios";
import selectPeopleVue from "@/components/process/performanceManagement/components/selectPeople.vue";
import DateUtil from "../../../util/DateUtil";
export default {
  components: { selectPeopleVue },
  data() {
    return {
      loading: false,
      date: new DateUtil(),
      pageInfo: {
        itemCount: 0,
        pageNo: 1,
        pageSize: 10
      },
      formItem: {},
      total: 0,
      columns: [
        {
          title: "代理人",
          key: "agentUserName",
          slot: "agentUserName",
          align: "center",
          minWidth: 140
        },
        {
          title: "被代理人",
          key: "userName",
          slot: "userName",
          align: "center",
          minWidth: 140
        },
        {
          title: "代理开始日期",
          key: "startDate",
          slot: "startDate",
          align: "center",
          minWidth: 140
        },
        {
          title: "代理结束日期",
          key: "endDate",
          slot: "endDate",
          align: "center",
          minWidth: 140
        },
        {
          title: "操作",
          slot: "action1",
          align: "center",
          minWidth: 140
        }
      ],
      data: [],
      targetIndex: "",
      keyName: ""
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.loading = true;
      axios
        .post("/agentApprovalSetting/selectAgentApprovalInfo", {
          ...this.pageInfo,
          ...this.formItem
        })
        .then(res => {
          this.loading = false;
          if (res) {
            this.data = res.data;
            this.total = parseInt(res.pageInfo.total);
          }
        });
    },
    addRow() {
      this.data.push({
        agentSerialnumber: "",
        agentEmpCode: "",
        agentUserName: "",
        userName: "",
        serialnumber: "",
        empCode: "",
        startDate: "",
        endDate: ""
      });
    },
    pageChange(val) {
      this.pageInfo.pageNo = val;
      this.getData();
    },
    targetItemChange(row, index, key) {
      if (key == "startDate" || key == "endDate") {
        this.$set(
          this.data[index],
          key,
          this.date.dateVal(row[`${key}`], "YYYY-MM-DD")
        );
      } else {
        key && this.$set(this.data[index], key, row[`${key}`]);
      }
    },
    onSelectPeraon(row, index, key) {
      this.targetIndex = index;
      this.keyName = key;
      this.$refs.peoModal.modal = true;
      this.$refs.peoModal.successorPeople = "9";
      this.$refs.peoModal.modelColumns.unshift({
        title: "选择",
        slot: "action1",
        align: "center",
        minWidth: 70
      });
    },
    onSaveRow(row, index) {
      if(!row.serialnumber || !row.agentSerialnumber || !row.startDate || !row.endDate){
        return this.$Message.error("保存项目不允许存在空值,请正常填写后进行保存");
      }
      row.startDate
        ? (row.startDate = this.date.dateVal(row.startDate, "YYYY-MM-DD"))
        : "";
      row.endDate
        ? (row.endDate = this.date.dateVal(row.endDate, "YYYY-MM-DD"))
        : "";
      if(row.endDate < row.startDate){
        return this.$Message.error("代理结束日期不允许小于代理开始日期");
      }
      axios
        .post("/agentApprovalSetting/saveAgentApprovalInfo", row)
        .then(res => {
          if (res) {
            this.$Message.success(res);
            this.getData();
          }
        });
    },
    onDeleteRow(row, index) {
      if (row.id) {
        axios
          .post("/agentApprovalSetting/deleteAgentApprovalInfo", { id: row.id })
          .then(res => {
            if (res) {
              this.$Message.success(res);
              this.getData();
            }
          });
      } else {
        this.data.splice(index, 1);
      }
    },
    onselect(row) {
      if (this.keyName == "agentUserName") {
        this.$set(this.data[this.targetIndex], "agentUserName", row.userName);
        this.$set(this.data[this.targetIndex], "agentEmpCode", row.empCode);
        this.$set(
          this.data[this.targetIndex],
          "agentSerialnumber",
          row.serialnumber
        );
      } else {
        this.$set(this.data[this.targetIndex], "userName", row.userName);
        this.$set(this.data[this.targetIndex], "empCode", row.empCode);
        this.$set(
          this.data[this.targetIndex],
          "serialnumber",
          row.serialnumber
        );
      }
    },
    onSelectList() {}
  }
};
</script>

<style lang="less" scoped></style>



// WEBPACK FOOTER //
// src/components/process/SystemSettings/AgentAsUserSet.vue